import React, { Component, ComponentType } from 'react';
import { compose } from 'recompose';
import { withTheme, WithTheme } from '@material-ui/core/styles';

import { ITimeline } from 'types/app';
import { USER_FEED_ID, USER_FEED_NAME } from 'constants/index';
import { withUser, IWithUser } from './UserContext';

export interface IWithTimeline {
  timelineFeed: ITimeline;
  timelineGroup: ITimeline;
}

const withTimeline = <T extends {}>(ChildComponent: ComponentType<T>) => {
  interface IPropsEnhanced extends WithTheme, IWithUser {}

  const enhancers = compose<IPropsEnhanced, T>(withTheme, withUser);

  class WithTimeline extends Component<T & IPropsEnhanced> {
    getTimelineFeed(): ITimeline {
      const { theme, user } = this.props;

      return {
        id: user.id,
        title: USER_FEED_NAME,
        color_map: {
          hex: theme.palette.secondary.main,
        },
      };
    }

    getTimelineGroup(): ITimeline {
      const { theme } = this.props;

      return {
        id: USER_FEED_ID,
        title: USER_FEED_NAME,
        color_map: {
          hex: theme.palette.secondary.main,
        },
      };
    }

    render() {
      const { ...props } = this.props as T;
      const timelineFeed = this.getTimelineFeed();
      const timelineGroup = this.getTimelineGroup();

      return (
        <ChildComponent timelineFeed={timelineFeed} timelineGroup={timelineGroup} {...props} />
      );
    }
  }

  return enhancers(WithTimeline);
};

export { withTimeline };
